import { ClientContextService } from '@sdbn/appclient';
import { ConfigurationService } from '@sdbn/appclient';
import { TranslationService } from '@sdbn/common';
import { HttpService } from '@sdbn/appclient';
import { AbstractStepController, FlowStepHandleResult, HandleResultType, StepControl, WizardServiceLocator } from '@sdbn/appclient';
import { ContextChange } from '@sdbn/appclient';
import { TerminalContextConstants } from 'src/tmc-common/model/terminal-context-constants';
import { DateTime } from 'luxon';

export class VisitorPrintIdentityCardController extends AbstractStepController {

    private terminalConnectorUrl: string;

    configurationService: ConfigurationService;
    clientContextService: ClientContextService;
    translationService: TranslationService;
    httpService: HttpService;

    constructor() {
        super();
        this.configurationService = WizardServiceLocator.injector.get(ConfigurationService);
        this.httpService = WizardServiceLocator.injector.get(HttpService);
        this.clientContextService = WizardServiceLocator.injector.get(ClientContextService);
        this.translationService = WizardServiceLocator.injector.get(TranslationService);
        const terminalHardwareUrl = this.configurationService.getDeviceParam('terminalhardwareconnector.url');
        if (terminalHardwareUrl != null && terminalHardwareUrl.value.trim().length > 0) {
          this.terminalConnectorUrl = this.configurationService.getDeviceParam('terminalhardwareconnector.url').value;
        }
    }

    onContextChange(contextChange: ContextChange) {
    }

    onRegisterToDashboardContext() {
      if (this.terminalConnectorUrl == null) {
        console.log('No terminalConnector URL configured. Skip printing');
        this.wizardComponent.next();
      } else {
        this.httpService.post(this.terminalConnectorUrl + '/io/printer/print', this.buildPrintJobData()).subscribe(result => {
          console.log('preint finished');
          this.wizardComponent.next();
        },
        error => {
          console.log('error received');
          this.wizardComponent.next();
        });
      }
    }

    public handleFlow(): FlowStepHandleResult {
      const result = new FlowStepHandleResult();
      result.type = HandleResultType.PROCESSING;
      return result;
    }

    getControls(): StepControl[] {
        return new Array<StepControl>();
    }

    private buildPrintJobData(): any {
      const context = this.clientContextService.getCurrentContext();
      const name = this.dashboardContext.getContextValue(TerminalContextConstants.lastname);
      const firstname = this.dashboardContext.getContextValue(TerminalContextConstants.firstname);
      const company = this.dashboardContext.getContextValue(TerminalContextConstants.company);
      const numberPlate = this.dashboardContext.getContextValue(TerminalContextConstants.numberPlate);
      const reason = this.dashboardContext.getContextValue(TerminalContextConstants.reasonForVisit);
      const visitedPerson = this.dashboardContext.getContextValue(TerminalContextConstants.visitedPerson);
      const registrationCode = this.dashboardContext.getContextValue(TerminalContextConstants.registrationCode);
      const registrationFinished = this.dashboardContext.getContextValue(TerminalContextConstants.registrationFinished);

      return {
        yardKey: context.unit.key,
        type: 'VISITOR_IDENTITY_CARD',
        labels: {
          'label.name': this.translationService.translate('tmc-yard.entity.visit.name'),
          'label.company': this.translationService.translate('tmc-yard.entity.visit.company'),
          'label.numberPlate': this.translationService.translate('tmc-yard.entity.visit.numberplate'),
          'label.reason': this.translationService.translate('tmc-yard.entity.visit.reason'),
          'label.visitedPerson': this.translationService.translate('tmc-yard.entity.visit.visited-person'),
          'label.registrationFinished': this.translationService.translate('tmc-yard.entity.visit.registrationFinished')

        },
        values: {
          name: name,
          firstname : firstname,
          company: company,
          numberPlate: numberPlate,
          reason:reason,
          visitedPerson: visitedPerson,
          registrationFinished: DateTime.fromJSDate(new Date(registrationFinished)).toFormat("dd.MM.yyyy HH:mm"),
          qrCode: registrationCode != null ? 'tmc-visit://visitor/' + registrationCode : null
        }
      };
    }
}
